import React, { FC } from 'react';
import classNames from 'classnames';
import LockIcon from '@mui/icons-material/Lock';

export interface AccountImageProps {
    image: string;
    showDefault?: boolean;
}

export const AccountImage: FC<AccountImageProps> = ({ image, showDefault }) => {
    const isCard = image.indexOf("card-") === 0;

    if (image.length > 0) {
        const classes = classNames({ "card-glyph": isCard }, image);
        return (<span className={classes}></span>);
    }
    if (showDefault) {
        return <LockIcon className="small-glyph"/>;
    }
    return null;
};
